import React from 'react';
import PropTypes from 'prop-types';

export default class Forbidden extends React.Component {
	static propTypes = {
		errorMessage: PropTypes.string,
	};

	render() {
		return (
			<div className="forbidden" style={{ margin: '5rem' }}>
				<h2>Access Denied</h2>
				<p>
					Uh oh... looks like you are not authorized to view this
					page.
				</p>
				<p>{this.showError()}</p>
			</div>
		);
	}

	showError() {
		const { errorMessage: msg } = this.props;
		return msg && typeof msg === 'string' ? msg : null;
	}
}
